const CDN_BASE = "https://static.pw.live/5eb393ee95fab7468a79d189";

export const cdnImages = {
  conceptLecture: `${CDN_BASE}/a66c8c3d-5a3b-4003-b6fd-37fe0ef8e4ba.webp`,
  testArena: `${CDN_BASE}/ef61782e-d184-4acc-b412-28644e1c5c99.webp`,
  teachers: `${CDN_BASE}/b14c29e5-c44b-4ea2-a8f7-8e1e75ce0ed3.webp`,
  askAi: `${CDN_BASE}/e9c718a0-7285-44fa-a87a-74799d14dab8.webp`,
  heroAlakh: `${CDN_BASE}/dace4e6d-40ee-44a2-9d65-01cb97be48f4.webp`,
  educators: {
    rajwant: `${CDN_BASE}/44783146-1f9f-4226-904b-240095702ef8.webp`,
    pankaj: `${CDN_BASE}/e1ba8d53-470f-4369-8f0e-45ccd004b6fe.webp`,
    manish: `${CDN_BASE}/cf5c7b38-610a-4a02-a123-4e8995da2569.webp`,
    sujeet: `${CDN_BASE}/c5976988-2983-4da7-9c9e-84f036283f54.webp`,
    hitesh: `${CDN_BASE}/47caacb4-e2ab-44b1-bcd9-3c9d1da2930b.webp`,
    tulika: `${CDN_BASE}/cfc1d5d4-edb4-45d0-b9d7-5288f510dea9.webp`,
    samapti: `${CDN_BASE}/2630ecd3-f223-4417-94c2-3723bacb81a3.webp`,
  },
} as const;

export const CDN_ORIGIN = "https://static.pw.live";
